import { render, staticRenderFns } from "./DisputeInformation.vue?vue&type=template&id=5a41bade&scoped=true"
import script from "./DisputeInformation.vue?vue&type=script&lang=js"
export * from "./DisputeInformation.vue?vue&type=script&lang=js"
import style0 from "./DisputeInformation.vue?vue&type=style&index=0&id=5a41bade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41bade",
  null
  
)

export default component.exports